<template>
  <div class="page page-products">
    <DefaultHeader />

    <div>
      <router-link :to="{ name: 'products' }">
        <button class="back btn btn-lg ml-3">CONTINUAR COMPRANDO</button>
      </router-link>
    </div>

    <section class="items-container row">
      <Product
        v-for="item in getCart.items"
        :key="item.product.id"
        :product="item.product"
      />
    </section>

    <CartFooter />
  </div>
</template>

<script>
  import DefaultHeader from "../DefaultHeader";
  import Product from "../Products/Product";
  import { mapGetters } from "vuex";
  import CartFooter from "./CartFooter";

  export default {
    name: "Cart",
    components: { CartFooter, Product, DefaultHeader },
    computed: {
      ...mapGetters({ getCart: "getCart" }),
    },
  };
</script>

<style scoped>
  .page-products {
    background-color: #f5e8d9;
  }

  .back {
    background-color: #f16521;
    color: #fff;
  }

  .items-container {
    padding-bottom: 400px;
    min-height: calc(100vh - 400px);
  }
</style>
